import '../fesd/fesd'
import '../../sass/brand/brand_intro_list.sass'
import { _dropdown } from '../includes/_dropdown.js'

$(function(){
  _dropdown.all()
  _common.comDropdown('.ft-lang >div');
})